// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';

tinymce.baseURL = '/tinymce';

class TinyMceEditor extends WebComponent {
  didMount() {
    let autoFocus = false;
    if (this.element.dataset.autoFocus === 'true') {
      autoFocus = `${this.element.id}`;
    }

    tinymce.init({
      selector: `#${this.element.id}`,
      auto_focus: autoFocus,
      menubar: false,
      schema: 'html5',
      fixedToolbar: true,
      browser_spellcheck: true,
      relative_urls: false,
      convert_urls: false,
      autoresize_min_height: 200,
      autoresize_max_height: 600,
      toolbar1: 'bold italic underline strikethrough | blockquote | bullist numlist | image | undo redo | link unlink | removeformat | media | code',
      language: 'cs',
      plugins: 'image link code lists media paste',
      paste_as_text: true,
      media_dimensions: false,
      media_alt_source: false,
      media_poster: false,
      paste_data_images: true,
      content_css: '/build/web.css?v02',
      entity_encoding: 'raw',
      valid_elements: '@[id|class|title|style|tabindex|alt],a[rel|href|target],strong/b,em/i,strike,u,#p,-ol[type],-ul[type],-li,br,img[src|alt|width|height],-sub,-sup,-blockquote/blockquote,-table[border|cellspacing|cellpadding|width|height|align|summary],-tr[rowspan|width|height|align|valign],tbody,thead,tfoot,#td[colspan|rowspan|width|height|align|valign],#th[colspan|rowspan|width|height|align|valign|scope],caption,div[data-size],span,-h2,-h3,-h4,dd,dl,dt,del,details,summary,svg[class],use[xlink?href],iframe[*],button[data-action|data-action-trigger],hr',
      setup(editor) {
        editor.on('change', () => {
          tinymce.triggerSave();
        });
      },
      images_upload_handler(blobInfo, success, failure) {
        const image_size = blobInfo.blob().size / 1000; // image size in kbytes
        const max_size = 1024;
        if (image_size > max_size) {
          failure('Obrázek je příliš velký. Maximální povolená velikost je 1 MB.');
          //tinymce.activeEditor.undoManager.undo();
          const img = tinymce.activeEditor.dom.doc.querySelector('img[src^="blob:"]');
          img.src = '/img/spacer.gif';
          img.width = '0';
          img.height = '0';
          img.style = 'position: absolute; left: 9999px; top: 9999px;'
        } else {
          success(`data:${blobInfo.blob().type};base64,${blobInfo.base64()}`);
        }
      },
      // escapping from blockquote
      init_instance_callback(editor) {
        editor.on('KeyDown', (e) => {
          if (e.keyCode == 27) {
            const editor = tinyMCE.activeEditor;
            const dom = editor.dom;
            const parentBlock = tinyMCE.activeEditor.selection.getSelectedBlocks()[0];
            const containerBlock = parentBlock.parentNode.nodeName == 'BODY' ? dom.getParent(parentBlock, dom.isBlock) : dom.getParent(parentBlock.parentNode, dom.isBlock);
            const newBlock = tinyMCE.activeEditor.dom.create('p');
            newBlock.innerHTML = '<br data-mce-bogus="1">';
            dom.insertAfter(newBlock, containerBlock);
            const rng = dom.createRng();
            newBlock.normalize();
            rng.setStart(newBlock, 0);
            rng.setEnd(newBlock, 0);
            editor.selection.setRng(rng);
          }
        });
      },
      file_picker_callback(cb, value, meta) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        /*
          Note: In modern browsers input[type="file"] is functional without
          even adding it to the DOM, but that might not be the case in some older
          or quirky browsers like IE, so you might want to add it to the DOM
          just in case, and visually hide it. And do not forget do remove it
          once you do not need it anymore.
        */

        input.onchange = function () {
          const file = this.files[0];

          const reader = new FileReader();
          reader.onload = function () {
            /*
              Note: Now we need to register the blob in TinyMCEs image blob
              registry. In the next release this part hopefully won't be
              necessary, as we are looking to handle it internally.
            */
            const id = `blobid${(new Date()).getTime()}`;
            const blobCache = tinymce.activeEditor.editorUpload.blobCache;
            const base64 = reader.result.split(',')[1];
            const blobInfo = blobCache.create(id, file, base64);
            blobCache.add(blobInfo);

            /* call the callback and populate the Title field with the file name */
            cb(blobInfo.blobUri(), { title: file.name });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
    });
  }
  willUnMount() {
    const editor = tinymce.get(this.element.id);
    if (editor) {
      editor.remove();
    }
  }
}

export default TinyMceEditor;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TinyMceEditor.js